import { LinkUtils } from 'src/utils/link'
import { GetUrlPreviewLinkProps } from './getUrlPreviewLink.types'

export const getUrlPreviewLink = ({ description, link }: GetUrlPreviewLinkProps) => {
  if (!description?.trim?.()?.length) return ''

  const match = LinkUtils.extractURLfromText(description)

  if (!link && match) return match

  if (link && !match) {
    return ''
  }

  if (link === match) {
    return link
  }

  return match
}
